import preferences from './preferences';

export default {
  preferences,
};
